import { z } from 'zod';

/**
 * @aiPurpose payload describing a pending agent proposal — a suggested
 *   glossary term or memory entry that an admin can later approve or reject.
 *   Streamed on `glossary_proposal_created` / `memory_proposal_created` v2
 *   events.
 * @aiSecurity STRUCTURALLY incapable of carrying raw SQL, a model prompt, a
 *   secret, a phone value, or a row dump — every field is a closed `.strict()`
 *   scalar with a bounded `.max()`. `title`/`summary`/`adminActionHint` are
 *   safe, pre-redacted human strings only.
 * @aiInvariant `kind` selects which proposal store the admin flow targets;
 *   the event wrapper asserts the expected kind at the throw layer.
 */
export const AgentProposalPayloadSchema = z
  .object({
    proposalId: z.string(),
    kind: z.enum(['glossary', 'memory']),
    title: z.string().max(200),
    summary: z.string().max(1000),
    status: z.enum(['pending', 'approved', 'rejected']),
    adminActionHint: z.string().max(200).optional(),
  })
  .strict();

export type AgentProposalPayload = z.infer<typeof AgentProposalPayloadSchema>;
